import React from "react";
import ButtonClose from "../ButtonClose/ButtonClose"
import { Container, Title, Title2, Conditions, DescriptionText, SubTitle, StepContainer, TextContainer, FirstStep, SecondStep, ThirdStep, ButtonContainer, ButtonAcept, TrazoContextoImg, LogoContainer, NumberOne, NumberTwo } from "../../Styles/Context/ContextStyle"
import LogoBank from "../ImageLogo/LogoBank"

function Context({cancel, acept, enrollment}) {

  const title = enrollment ? "Registrate en biometría facial" : "Autentícate en biometría facial";
  const subTitle1 = "Prepara la cámara de tu teléfono";
  const subTitle2 = "Ten tu documento físico a la mano";
  const subTitle3 = "Usa navegadores recomendados";
  const condition1 = "Utilizaremos la cámara frontal y posterior de tu teléfono móvil";
  const condition2 = "Es posible que te lo pidamos.";
  const condition3 = "Chrome, Safari, GSA y Webkit.";
  const littleTitle = "Una vez inicies tu validación, debes finalizarla, el proceso durará aproximadamente 10 minutos";
  const buttonText = "Continuar";

  return (
    <Container>
      <TrazoContextoImg/>
      <ButtonClose cancel={cancel}/>
      <LogoBank marginTop={"29px"} marginBottom={"36px"}/>
        <Conditions>
        <Title>{title}</Title>
          <StepContainer>
            <FirstStep/>
            <TextContainer>
                <SubTitle>{subTitle1}</SubTitle>
                <DescriptionText>{condition1}</DescriptionText>
            </TextContainer>
          </StepContainer>
          {enrollment && (
            <StepContainer>
            <SecondStep/>
            <TextContainer>
                <SubTitle>{subTitle2}</SubTitle>
                <DescriptionText>{condition2}</DescriptionText>
            </TextContainer>
          </StepContainer>
          )}
          <StepContainer>
            <ThirdStep/>
            <TextContainer>
                <SubTitle>{subTitle3}</SubTitle>
                <DescriptionText>{condition3}</DescriptionText>
            </TextContainer>
          </StepContainer>
          </Conditions>
        <Title2>{littleTitle}</Title2>
     <LogoContainer>
        <NumberOne/>
        <NumberTwo/>
      </LogoContainer>
      <ButtonContainer>
        <ButtonAcept onClick={acept}>{buttonText}</ButtonAcept>
      </ButtonContainer>
    </Container>
  );
}
export default Context;
